import { Component, inject, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ChartSize, TableColumn, TableData, TableRow } from '@models';
import { CommonFunctionsService } from '@services';

@Component({
  selector: 'drilldown-table',
  templateUrl: './drilldown-table.component.html',
  styleUrl: './drilldown-table.component.scss'
})
export class DrilldownTableComponent implements OnInit {
  private commonFunctionsService: CommonFunctionsService = inject(CommonFunctionsService);

  @Input() data!: TableData;
  @Input() size!: ChartSize;
  dataSource = new MatTableDataSource<TableRow>([]);
  displayedColumns: TableColumn[] = [];
  displayedColumnsKeys: string[] = [];
  noDataAvailable = false;

  ngOnInit() {
    if (this.data.rows.length === 0) {
      this.noDataAvailable = true;
      return;
    }

    this.dataSource.data = this.data.rows;
    this.setDisplayedColumns();
  }

  getColumnClass(column: TableColumn): string | undefined {
    if (column.isBadge) {
      switch (this.size) {
        case 'small':
        case 'medium':
          return 'mat-column-badge-no-label';
        case 'large':
          return 'mat-column-badge-with-label';
      }
    }

    if (column.key == 'milestoneName') return 'mat-column-milestone-name';

    return;
  }

  formatLabel(column: TableColumn, label: string): string | undefined {
    if (column.isDate) {
      return this.commonFunctionsService.formatUndefinedDate(label);
    }

    return label;
  }

  private setDisplayedColumns() {
    this.data.columns.forEach((column) => {
      if (column.alwaysVisible || column.visibleSizes?.includes(this.size)) {
        this.displayedColumns.push(column);
        this.displayedColumnsKeys.push(column.key);
      }
    });
  }
}
